import { render, staticRenderFns } from "./CommunityIndex.vue?vue&type=template&id=7b73bbfa&scoped=true"
import script from "./CommunityIndex.vue?vue&type=script&lang=js"
export * from "./CommunityIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b73bbfa",
  null
  
)

export default component.exports